import React from 'react';

export default {
  icon: (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='2' y='2.5' width='20' height='20' fill='white' />
      <g clipPath='url(#clip0_10853_30543)'>
        <path
          d='M19 0.5H5C3.67441 0.501588 2.40356 1.02888 1.46622 1.96622C0.528882 2.90356 0.00158786 4.17441 0 5.5L0 19.5C0.00158786 20.8256 0.528882 22.0964 1.46622 23.0338C2.40356 23.9711 3.67441 24.4984 5 24.5H19C20.3256 24.4984 21.5964 23.9711 22.5338 23.0338C23.4711 22.0964 23.9984 20.8256 24 19.5V5.5C23.9984 4.17441 23.4711 2.90356 22.5338 1.96622C21.5964 1.02888 20.3256 0.501588 19 0.5ZM22 19.5C22 20.2956 21.6839 21.0587 21.1213 21.6213C20.5587 22.1839 19.7956 22.5 19 22.5H5C4.20435 22.5 3.44129 22.1839 2.87868 21.6213C2.31607 21.0587 2 20.2956 2 19.5V5.5C2 4.70435 2.31607 3.94129 2.87868 3.37868C3.44129 2.81607 4.20435 2.5 5 2.5H19C19.7956 2.5 20.5587 2.81607 21.1213 3.37868C21.6839 3.94129 22 4.70435 22 5.5V19.5Z'
          fill='#0D2A3A'
        />
      </g>
      <defs>
        <clipPath id='clip0_10853_30543'>
          <rect width='24' height='24' fill='white' transform='translate(0 0.5)' />
        </clipPath>
      </defs>
    </svg>
  ),
  checkedIcon: (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_10853_30531)'>
        <path
          d='M19 0.5H5.00002C2.23997 0.503328 0.00332812 2.73997 0 5.50002V19.5C0.00332812 22.26 2.23997 24.4967 5.00002 24.5H19C21.76 24.4967 23.9967 22.26 24 19.5V5.50002C23.9967 2.73997 21.76 0.503328 19 0.5ZM20 8.579L10.746 17.833C9.96511 18.6142 8.69878 18.6145 7.91756 17.8336C7.91738 17.8334 7.91719 17.8332 7.917 17.833L3.99998 13.917C3.60867 13.5257 3.60867 12.8913 3.99998 12.5C4.3913 12.1088 5.0257 12.1087 5.41697 12.5L9.33295 16.416L18.588 7.16202C18.9793 6.77211 19.6125 6.77323 20.0025 7.1645C20.3924 7.55581 20.3913 8.18909 20 8.579Z'
          fill='#0088FF'
        />
      </g>
      <defs>
        <clipPath id='clip0_10853_30531'>
          <rect width='24' height='24' fill='white' transform='translate(0 0.5)' />
        </clipPath>
      </defs>
    </svg>
  ),

  indeterminateIcon: (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='2' y='2.5' width='20' height='20' fill='white' />
      <g clipPath='url(#clip0_10853_30511)'>
        <path
          d='M19 0.5H5C3.67441 0.501588 2.40356 1.02888 1.46622 1.96622C0.528882 2.90356 0.00158786 4.17441 0 5.5L0 19.5C0.00158786 20.8256 0.528882 22.0964 1.46622 23.0338C2.40356 23.9711 3.67441 24.4984 5 24.5H19C20.3256 24.4984 21.5964 23.9711 22.5338 23.0338C23.4711 22.0964 23.9984 20.8256 24 19.5V5.5C23.9984 4.17441 23.4711 2.90356 22.5338 1.96622C21.5964 1.02888 20.3256 0.501588 19 0.5ZM22 19.5C22 20.2956 21.6839 21.0587 21.1213 21.6213C20.5587 22.1839 19.7956 22.5 19 22.5H5C4.20435 22.5 3.44129 22.1839 2.87868 21.6213C2.31607 21.0587 2 20.2956 2 19.5V5.5C2 4.70435 2.31607 3.94129 2.87868 3.37868C3.44129 2.81607 4.20435 2.5 5 2.5H19C19.7956 2.5 20.5587 2.81607 21.1213 3.37868C21.6839 3.94129 22 4.70435 22 5.5V19.5Z'
          fill='#0088FF'
        />
      </g>
      <rect x='6' y='6.5' width='12' height='12' rx='2' fill='#0088FF' />
      <defs>
        <clipPath id='clip0_10853_30511'>
          <rect width='24' height='24' fill='white' transform='translate(0 0.5)' />
        </clipPath>
      </defs>
    </svg>
  ),
};
